module.exports = __webpack_public_path__ + "img/whatsapp.a7868de0.svg";